import { toast } from 'react-toastify';
import { API_BASE_URL_AI, API_BASE_URL } from '../../utils/config';
import { insertarUltimoAnalisis } from "../../utils/mapUtils";
import { fetchDataDeteccionMaleza } from './deteccionMalezaFetch';
import axios from 'axios';

export const ejecutarProcesoDeteccionMaleza = async ({
    selectedZipFile,
    setProcessingFinished,
    setImageUrl,
    setShapefileUrl = null, // Añadimos un nuevo setter para la URL del shapefile (opcional)
    setNorthWestCoords,
    setSouthEastCoords,
    setAreaMaleza,
    setPorcentajeMaleza,
    setAreaPoligono,
    setDatosAnalisis = null, // Añadir setDatosAnalisis para actualizar datos inmediatamente
    socket,
    socketSessionID,
    setProgress,
    setTitleLoader,
    setShowProgressBar,
    selectedAnalysisTypeRef,
    idAnalisisBash,
    nombre,
    userId,
    calidad,
    usarShapefile = false, // Nueva opción para usar shapefile
    metadatos = null, // Nuevos metadatos para la detección
    idTemporal = null // ID temporal de los datos pendientes
}) => {
    try {
        setProgress(0);
        setTitleLoader("Iniciando detección de maleza...");

    if (!selectedZipFile) {
        toast.error("Por favor selecciona un archivo ZIP antes de continuar.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: true,
        });
        return;
    }

    const result = await insertarUltimoAnalisis(
        selectedAnalysisTypeRef,
        idAnalisisBash,
        nombre,
        userId
    );

    localStorage.removeItem('deteccionMaleza_lotesData');
    localStorage.removeItem('deteccionMaleza_shapefileUrl');

    if (idTemporal) {
        try {
            await axios.patch(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}/iniciar`);
        } catch (error) {
            console.warn('⚠️ No se pudo marcar el inicio del análisis:', error);
        }
    }

    const CHUNK_SIZE = 10 * 1024 * 1024;
    setProgress(10);
    setTitleLoader("Preparando archivo...");

    // Usar el archivo directamente, sin FileReader
    const totalChunks = Math.ceil(selectedZipFile.size / CHUNK_SIZE);
    const worker = new Worker('Workers/WeedDetectionWorker.js');

    let processedChunks = 0;

    worker.postMessage({
        file: selectedZipFile,
        chunkSize: CHUNK_SIZE,
        apiUrl: `${API_BASE_URL_AI}detection/weed/maleza`,
        sessionID: socketSessionID,
        totalChunks: totalChunks,
        idAnalisis: result.data.idAnalisis,
        calidad,
        usarShapefile,
        outputDir: socketSessionID // Usar el sessionID como output_dir único
    });

    worker.onmessage = (event) => {
        // Estado original: solo muestra progreso de fragmentos subidos
        if (event.data.progress) {
            processedChunks++;
            const progressPercentage = 20 + ((processedChunks / totalChunks) * 70);
            setProgress(progressPercentage.toFixed(2));
            setTitleLoader(`Subiendo fragmentos (${processedChunks}/${totalChunks})...`);
            if (socket) {
                socket.emit(`${socketSessionID}:progressUpdate`, { progress: event.data.progress });
            }
        } else if (event.data.error) {
            console.error(event.data.error);
            worker.terminate();
            setShowProgressBar(false);

            if (idTemporal) {
                axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`)
                    .then(() => {
                        localStorage.removeItem('deteccionMaleza_idTemp');
                    })
                    .catch((deleteError) => {
                        console.error('❌ Error al eliminar registro:', deleteError);
                    });
            }

            toast.error('Error al subir fragmento: ' + event.data.error, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: true,
            });
        } else if (event.data.status === 'coverage_error') {
            worker.terminate();
            setShowProgressBar(false);

            if (idTemporal) {
                axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`)
                    .then(() => {
                        localStorage.removeItem('deteccionMaleza_idTemp');
                    })
                    .catch((deleteError) => {
                        console.error('❌ Error al eliminar registro:', deleteError);
                    });
            }

            toast.warning(event.data.error, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else if (event.data.status === 'error') {
            worker.terminate();
            setShowProgressBar(false);

            if (idTemporal) {
                axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`)
                    .then(() => {
                        localStorage.removeItem('deteccionMaleza_idTemp');
                    })
                    .catch((deleteError) => {
                        console.error('❌ Error al eliminar registro:', deleteError);
                    });
            }

            toast.error('Error en el procesamiento: ' + event.data.error, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: true,
            });
        } else if (event.data.status === 'complete') {
            setProgress(100);
            // setTitleLoader("Proceso completado.");
            setShowProgressBar(false);

            const {
                imageUrl,
                shapefileUrl,
                northWestCoords,
                southEastCoords,
                areaMaleza,
                areaPoligono,
                porcentajeMaleza,
                lotes_data
            } = event.data;

            setImageUrl(imageUrl);

            if (shapefileUrl) {
                if (typeof setShapefileUrl === 'function') {
                    setShapefileUrl(shapefileUrl);
                }
                localStorage.setItem('deteccionMaleza_shapefileUrl', shapefileUrl);
            }

            // Guardar coordenadas
            setNorthWestCoords(northWestCoords);
            setSouthEastCoords(southEastCoords);

            // Guardar métricas
            setAreaMaleza(areaMaleza);
            setAreaPoligono(areaPoligono);
            setPorcentajeMaleza(porcentajeMaleza);

            // Actualizar datosAnalisis inmediatamente si está disponible
            if (setDatosAnalisis && typeof setDatosAnalisis === 'function') {
                fetchDataDeteccionMaleza(areaMaleza, setDatosAnalisis, areaPoligono, porcentajeMaleza);
            } else {
                console.warn('⚠️ [deteccionMalezaProcess] setDatosAnalisis no disponible, dependiendo del useEffect del Dashboard');
            }

            // Guardar datos de lotes en localStorage para usar en componentes de tabla
            if (lotes_data && lotes_data.length > 0) {
                // Intentar añadir precio por hectárea desde metadatos temporales si existe
                let metadatosTemp = null;
                try {
                    metadatosTemp = JSON.parse(localStorage.getItem('deteccionMaleza_datos_temp')) || null;
                } catch (e) {
                    metadatosTemp = null;
                }

                const precioPorHa = metadatosTemp && metadatosTemp.precioPorHa !== undefined ? Number(metadatosTemp.precioPorHa) : null;

                const lotesWithPrecio = lotes_data.map(lote => ({
                    ...lote,
                    precio_usd_ha: precioPorHa
                }));

                const dataWithTimestamp = {
                    data: lotesWithPrecio,
                    timestamp: Date.now(),
                    analysisCompleted: true
                };
                localStorage.setItem('deteccionMaleza_lotesData', JSON.stringify(dataWithTimestamp));
            }

            if (idTemporal && result.data && result.data.idAnalisis) {

                localStorage.setItem('deteccionMaleza_idReal', String(result.data.idAnalisis));

                axios.patch(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}/completar-con-datos`, {
                    idAnalisisReal: result.data.idAnalisis,
                    areaMaleza: areaMaleza,
                    areaPoligono: areaPoligono,
                    porcentajeMaleza: porcentajeMaleza,
                    lotesData: (() => {
                        try {
                            const metadatosTemp = JSON.parse(localStorage.getItem('deteccionMaleza_datos_temp')) || null;
                            const precioPorHa = metadatosTemp && metadatosTemp.precioPorHa !== undefined ? Number(metadatosTemp.precioPorHa) : null;
                            if (precioPorHa === null) return event.data.lotes_data;
                            return (event.data.lotes_data || []).map(lote => ({ ...lote, precio_usd_ha: precioPorHa }));
                        } catch (e) {
                            return event.data.lotes_data;
                        }
                    })()
                })
                .then((response) => {

                    localStorage.removeItem('deteccionMaleza_idTemp');

                }).catch((error) => {
                    console.error('❌ Error al completar análisis con ID:', error);

                    axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`)
                        .then(() => {
                        })
                        .catch((deleteError) => {
                            console.error('❌ Error al eliminar registro temporal:', deleteError);
                        });

                    toast.warning('Análisis completado pero hubo un problema al guardar los datos', {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 5000,
                    });
                });
            }

            toast.success('Análisis completado exitosamente. Cargando imagen...', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
                hideProgressBar: true,
            });

            worker.terminate();
            setProcessingFinished(true);
        }
    };

    } catch (generalError) {
        console.error('❌ Error general en ejecutarProcesoDeteccionMaleza:', generalError);

        // Eliminar registro en caso de error general
        if (idTemporal) {
            axios.delete(`${API_BASE_URL}deteccion-maleza/datos/${idTemporal}`)
                .then(() => {
                    localStorage.removeItem('deteccionMaleza_idTemp');
                    localStorage.removeItem('deteccionMaleza_datos_temp');
                })
                .catch((deleteError) => {
                    console.error('❌ Error al eliminar registro:', deleteError);
                });
        }

        setShowProgressBar(false);
        setProcessingFinished(false);

        toast.error('Error inesperado durante el análisis. El proceso ha sido cancelado.', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
        });

        // Re-throw el error para que el Dashboard también lo pueda manejar
        throw generalError;
    }
}
